import * as yup from 'yup';
import { validateEmail } from 'src/validations';

export const validationSchema = yup
  .object()
  .shape({
    email: validateEmail
  })
  .defined();
